// extracted by mini-css-extract-plugin
module.exports = {"NumericRangeFeature":"vt_a bha_b bha_ux"};